// src/components/charts/core/ChartMissing.tsx
/**
 * ChartMissing - Placeholder for missing/not-found charts
 * 
 * Used when a chart reference is invalid or the chart spec is not available.
 */

import React from "react";
import { motion } from "framer-motion";
import { BarChart3 } from "lucide-react";

// ─────────────────────────────────────────────────────────────────────────────
// Types
// ─────────────────────────────────────────────────────────────────────────────

export interface ChartMissingProps {
  /** Optional chart ID for reference */
  chartId?: string;
  /** Disable animation */
  disableAnimation?: boolean;
}

// ─────────────────────────────────────────────────────────────────────────────
// Component
// ─────────────────────────────────────────────────────────────────────────────

const ChartMissing: React.FC<ChartMissingProps> = ({
  chartId,
  disableAnimation = false,
}) => {
  const Wrapper = disableAnimation ? "div" : motion.div;
  const wrapperProps = disableAnimation ? {} : {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
  };

  return (
    <Wrapper
      {...wrapperProps}
      className="rounded-2xl border border-white/10 bg-gray-900/40 p-5 my-5"
    >
      <div className="flex items-center gap-2 text-white/40">
        <BarChart3 className="h-4 w-4" />
        <span className="text-sm">Chart not found{chartId ? `: ${chartId}` : ""}</span>
      </div>
    </Wrapper>
  );
};

export default ChartMissing;

